"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "main": "#00baff",
    "on-main": "#fff",
};
// Path: src/tokens/colors/brand.ts
//# sourceMappingURL=brand.js.map